/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enums
 */
export enum DocumentType {
    Script = 'Script',
    Storyboard = 'Storyboard',
    ShootingSchedule = 'Shoot Schedule',
    MediaPlan = 'Media Plan',
    Contract = 'Contract',
    License = 'License',
    Generic = 'Generic',
}
